import React, { useState } from 'react';

const API = 'https://khepri.tech/api/v1';

function Import() {
  const [source, setSource] = useState('1c');
  const [data, setData] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('khepri_token');

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => setData(event.target.result);
    reader.readAsText(file);
  };

  const importData = async () => {
    if (!data) { alert('Загрузите файл или вставьте данные'); return; }
    setLoading(true);
    try {
      const res = await fetch(API + '/import', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ source, data }),
      });
      const d = await res.json();
      setResult(d);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const SOURCES = [
    { value: '1c', label: '1С:Бухгалтерия', icon: '📊', format: 'CSV или XML' },
    { value: 'excel', label: 'Excel', icon: '📗', format: 'CSV или XLSX' },
    { value: 'csv', label: 'CSV-файл', icon: '📄', format: 'CSV' },
    { value: 'manual', label: 'Вставить вручную', icon: '✍️', format: 'Любой текст' },
  ];

  return (
    <div>
      <h2 style={{ color: '#F7DE8A' }}>📥 Импорт данных</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Загрузите данные из 1С или Excel — Khepri перенесёт контрагентов, договоры и товары.
      </p>

      {/* Выбор источника */}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 20 }}>
        {SOURCES.map(s => (
          <button key={s.value} onClick={() => setSource(s.value)}
            style={{ padding: '12px 20px', background: source === s.value ? '#F7DE8A' : '#1E293B', color: source === s.value ? '#0F172A' : '#94A3B8', border: '1px solid #8A6636', borderRadius: 12, cursor: 'pointer', fontSize: 13, fontWeight: source === s.value ? 700 : 500, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 20 }}>{s.icon}</span>
            <div style={{ textAlign: 'left' }}>
              <div>{s.label}</div>
              <div style={{ fontSize: 10, opacity: 0.7 }}>{s.format}</div>
            </div>
          </button>
        ))}
      </div>

      {/* Загрузка файла */}
      <div style={{ padding: 20, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636', marginBottom: 20 }}>
        <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>📁 Загрузите файл</h3>
        <input type="file" accept=".csv,.txt,.xml,.xlsx" onChange={handleFile} style={{ marginBottom: 12, color: '#94A3B8' }} />
        <textarea value={data} onChange={e => setData(e.target.value)} placeholder="Или вставьте данные вручную..." rows={6} style={{ width: '100%', padding: 12, background: '#0F172A', border: '1px solid #8A6636', borderRadius: 8, color: '#F8FAFC', fontSize: 13, resize: 'vertical' }} />
        <button onClick={importData} disabled={loading} style={{ marginTop: 12, padding: '14px 32px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: loading ? 'default' : 'pointer', fontWeight: 700, fontSize: 15, opacity: loading ? 0.6 : 1 }}>
          {loading ? 'Импорт...' : '📥 Импортировать'}
        </button>
      </div>

      {/* Результат */}
      {result && (
        <div style={{ padding: 16, background: 'rgba(16,185,129,0.15)', border: '1px solid #10B981', borderRadius: 12 }}>
          <strong style={{ color: '#10B981' }}>✅ Импорт завершён</strong>
          <p style={{ color: '#94A3B8', marginTop: 6 }}>Источник: {result.source}</p>
          <p style={{ color: '#94A3B8' }}>Записей: {result.records}</p>
          <p style={{ color: '#94A3B8' }}>{result.message}</p>
        </div>
      )}

      {/* Инструкция */}
      <div style={{ marginTop: 20, padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636' }}>
        <h3 style={{ color: '#F7DE8A', marginBottom: 8, fontSize: 15 }}>📖 Как экспортировать из 1С</h3>
        <ol style={{ color: '#94A3B8', fontSize: 13, paddingLeft: 20, lineHeight: 1.7 }}>
          <li>Откройте 1С:Бухгалтерия</li>
          <li>Перейдите в раздел «Контрагенты»</li>
          <li>Нажмите «Ещё» → «Выгрузить в файл»</li>
          <li>Выберите формат CSV или Excel</li>
          <li>Сохраните файл и загрузите здесь</li>
        </ol>
      </div>
    </div>
  );
}

export default Import;